import { Box, CircularProgress, Stack, useTheme } from '@mui/material';

import Button from '@components/Button';

import { generalPredefinedPromptsTexts } from '../../../constants';
import { useDeleteGeneralPredefinedPromptGroup } from '../../../services/queries';

const CIRCULAR_PROGRESS_SIZE = 24;

interface DeleteGroupProps {
    groupId?: string;
    groupIndex: number;
    deleteDynamicField: (groupId: number) => void;
}

export const DeleteGroup = ({ groupId, groupIndex, deleteDynamicField }: DeleteGroupProps) => {
    const theme = useTheme();
    const { mutate: deleteGeneralPredefinedPromptGroup, isPending: isDeleting } =
        useDeleteGeneralPredefinedPromptGroup();

    const isNewGroup = !groupId;

    const handleClick = isNewGroup
        ? () => deleteDynamicField(groupIndex)
        : () => deleteGeneralPredefinedPromptGroup(groupId);

    return (
        <Stack direction='row' justifyContent='center' alignItems='center' gap={2}>
            <Button lighterFont onClick={handleClick} disabled={isDeleting}>
                {generalPredefinedPromptsTexts.deleteGroupButton}
            </Button>

            <Box width={CIRCULAR_PROGRESS_SIZE} height={CIRCULAR_PROGRESS_SIZE}>
                {isDeleting && (
                    <CircularProgress
                        size={CIRCULAR_PROGRESS_SIZE}
                        sx={{ color: theme.palette.customColors.purple }}
                    />
                )}
            </Box>
        </Stack>
    );
};
